import { Toaster } from "react-hot-toast"
import Navbar from "@/components/Navbar"
import HeroSection from "@/components/HeroSection"
import CatalogueSection from "@/components/CatalogueSection"
import SavoirFaireSection from "@/components/SavoirFaireSection"
import FaqSection from "@/components/FaqSection"
import BuySection from "@/components/BuySection"
import FooterSection from "@/components/FooterSection"
import CartDrawer from "@/components/CartDrawer"
import CookieConsent from "@/components/CookieConsent"
import Seo from "@/components/Seo"
import { getOrganizationJsonLd, getProductItemListJsonLd, getFaqJsonLd } from "@/lib/seoData"

function Home() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "#F8F2EB" }}>
      <Seo
        title="Clips'On — Le bouton sans couture, en un clic, 28 couleurs"
        description="Bouton vestimentaire breveté qui se pose sans couture ni outil, en quelques secondes. Capsule de couleur interchangeable, 28 coloris, 18 et 20 mm. Nylon 6/6."
        path="/"
        jsonLd={[getOrganizationJsonLd(), getProductItemListJsonLd(), getFaqJsonLd()]}
      />
      <Toaster position="top-center" />
      <Navbar />
      <HeroSection />
      <CatalogueSection />
      <SavoirFaireSection />
      <FaqSection />
      <BuySection />
      <FooterSection />
      <CartDrawer />
      <CookieConsent />
    </div>
  )
}

export default Home
